import { useSelector } from './basic'
import { filters } from 'components/Translations/T'
//import { cookie } from 'utils';

const publicLinks = [
  { to: '/about', label: 'sections/about' },
  { to: '/terms', label: 'sections/terms' },
  { to: '/privacy', label: 'sections/privacy' },
  { to: '/cookie', label: 'sections/cookies' },
  { to: '/faq', label: 'sections/help' },
]

const impressum = { to: '/impressum', label: 'sections/impressumLink|clean' }
const usc = { to: '/usc', label: 'sections/usc' }

const usePublicLinks = () => {
  const isUsa = useSelector(s => s.siteConfig.isUsa)
  const isGerman = useSelector(s => filters.clean(s.translations['sections/impressumLink']) != '')
  //const isGerman = cookie.getBasic('lc','').includes('de');
  return [...publicLinks, isUsa && usc, isGerman && impressum].filter(e => e)
}

export { usePublicLinks as default, usePublicLinks }
